import { Text, VStack } from '@chakra-ui/react';
import { InstallmentCalculatorModal } from 'components/InstallmentCalculatorModal';
import { MdPayment } from 'react-icons/md';
import { FaCalculator } from 'react-icons/fa';
import ConfigureAccount from 'views/access/default/ConfigureAccount';
import SectionCard from './SectionCard';

export default function PaymentsTab() {
  return (
    <VStack
      spacing={4}
      align="stretch"
    >
      <SectionCard
        title="Configurações de Pix"
        icon={MdPayment}
      >
        <Text
          fontSize="sm"
          color="gray.600"
          mb={3}
        >
          Configure sua chave Pix padrão para recebimento de pagamentos.
        </Text>
        <ConfigureAccount showEveryDay />
      </SectionCard>

      <SectionCard
        title="Calculadora de Parcelas"
        icon={FaCalculator}
      >
        <Text
          fontSize="sm"
          color="gray.600"
          mb={3}
        >
          Calcule o valor das parcelas para suas vendas.
        </Text>
        <InstallmentCalculatorModal />
      </SectionCard>
    </VStack>
  );
}
